import { useEffect, useState } from "react";
import { toast } from "react-toastify";

import Table from "../../../components/elements/table/Table";

import { setTitle } from "../../../helpers/MetaTag";

import { handleFilterChange, initialsValue } from "../../../helpers";
import DeleteModal from "../../../components/common/DeleteModal";
import { useDebounce } from "../../../hooks/useDebounce";
import LimitSelect from "../../../components/elements/LimitSelect";
// import { useGetPermission } from "../../hooks/useGetPermission";
import Search from "../../../components/form/Search";
// import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import {
  subscriptionList,
  subscriptionDelete,
} from "../../../services/subscriptionService";
import dayjs from "dayjs";

import ManageSubscriptionDrawer from "./drawer/ManageSubscriptionDrawer.js";
import Badge from "../../../components/elements/Badge";

import SubscriptionDetailsDrawer from "./drawer/SubscriptionDetailsDrawer.js";
import { useNavigate } from "react-router-dom";
import Indentification from "../../../components/elements/Indentification";

import useFetch from "../../../hooks/useFetch";
import useMutation from "../../../hooks/useMutation";
import { planList } from "../../../services/plansService.js";

const Subscription = ({ userId }) => {
  setTitle("Subscription");
  //   const { permission, status } = useGetPermission("faq");

  const [selectedItems, setSelectedItems] = useState([]);
  const [modalOpen, setModalOpen] = useState({ isOpen: false, data: null });
  const [keyword, setKeyword] = useState("");
  const search = useDebounce(keyword, 300);
  //   const queryClient = useQueryClient();
  const [deleteModal, setDeleteModal] = useState({
    isOpen: false,
    data: null,
  });
  const [filters, setFilters] = useState({
    limit: 10,
    page: 1,
    sortQuery: "ordering",
    planId: [],
  });
  const [detailsModal, setDetailsModal] = useState({
    isOpen: false,
    data: null,
  });
  useEffect(() => {
    if (userId) {
      setFilters((prev) => ({
        ...prev,
        userId: [userId],
      }));
    }
  }, [userId]);
  const { data: plans, isLoading: isPlanLoading } = useFetch({
    dependencies: ["plans"],
    fetchFunction: async () => {
      const res = await planList({ limit: 100 }); // or whatever your API supports
      return res?.docs;
    },
  });

  const shouldFetch = userId && filters?.userId?.length > 0;
  const { data, isLoading, updateData, isFetching, refetch } = useFetch({
    enabled: shouldFetch,
    dependencies: ["subscription", filters, search],
    fetchFunction: async () => {
      const { userId = [], planId = [], ...restFilters } = filters || {};
      const res = await subscriptionList({
        // ...filters,
        ...restFilters,
        ...Object.fromEntries(userId.map((val, i) => [`userId[${i}]`, val])),
        ...Object.fromEntries(planId.map((val, i) => [`planId[${i}]`, val])),
        ...(search && { keyword: search }),
      });
      if (res?.status !== 200) {
        toast.warning(res?.message);
      }
      return res?.docs;
    },
  });

  //   const handleDownloadReceipt = async (item) => {
  //     const fileName = `Receipt-${item?.invoiceId || "N/A"}.pdf`;
  //     const blob = await pdf(<DonationReciptPdf data={item} />).toBlob();
  //     fileSaver.saveAs(blob, fileName);
  //   };

  const tableHeadData = [
    {
      _id: 2,
      name: "Name",
      align: "left",
    },
    {
      _id: 3,
      name: "Email",
      align: "left",
    },
    {
      _id: 4,
      name: "Price",
      align: "left",
    },
    {
      _id: 5,
      name: "Plan Name",
      align: "left",
      isFilter: true,
      isFilterSearch: false,
      onFilter: (val) => {
        if (val?.length > 0) {
          setFilters((prev) => ({
            ...prev,
            planId: val.map((item) => item.value),
          }));
        } else {
          setFilters((prev) => {
            delete prev.planId;
            return { ...prev };
          });
        }
      },
      filterData: (plans?.data || []).map((plan) => ({
        value: plan._id,
        name: plan.name,
        type: "checkbox",
      })),
    },
    // {
    //   _id: 6,
    //   name: "Type",
    //   align: "left",
    // },
    {
      _id: 9,
      name: "Date",
      align: "left",
    },
    // {
    //   _id: 10,
    //   name: "Payment Method",
    //   align: "left",
    // },
    {
      _id: 11,
      name: "Status",
      align: "left",
    },
    {
      _id: 13,
      name: "Action",
      align: "left",
    },
  ];
  const navigate = useNavigate();

  // Table Body Data =====================>
  const tableData = data?.data?.map((item) => {
    return {
      _id: item?._id,
      rowData: [
        {
          _id: 2,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: (
            <div className="relative flex items-center cursor-pointer">
              <Indentification
                initial={initialsValue(
                  item?.userData?.firstName + " " + item?.userData?.lastName
                )}
                image={item?.userData?.image?.url}
                alt={item?.userData?.firstName}
                fill={true}
                className={""}
                size={"sm"}
              />
              <div
                className="text-md mx-2 text-slate-600 font-bold"
                onClick={(e) => setDetailsModal({ isOpen: true, data: item })}
              >
                {item?.userData?.firstName + " " + item?.userData?.lastName ||
                  "-"}
              </div>
            </div>
          ),
        },
        {
          _id: 3,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: item?.userData?.email || "-",
        },
        {
          _id: 4,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: item?.planData?.planPricingData?.price || "-",
        },
        {
          _id: 5,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: item?.planData?.name || "-",
        },
        // {
        //   _id: 6,
        //   type: "text",
        //   align: "left",
        //   cellClass: "!min-w-[100px]",
        //   data: item?.paymentType || "-",
        // },
        {
          _id: 9,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: item?.createdAt
            ? dayjs(item?.createdAt).format("DD MMM, YYYY")
            : "-",
        },
        // {
        //   _id: 10,
        //   type: "text",
        //   align: "left",
        //   cellClass: "!min-w-[100px]",
        //   data: <PaymentMethod type={item?.paymentMethod} />,
        // },
        {
          _id: 11,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: (
            <div className="flex gap-2 items-center">
              <Badge
                type={
                  item?.paymentGateway?.status === "active"
                    ? "success"
                    : "danger"
                }
                label={
                  item?.paymentGateway?.status === "active"
                    ? "Active"
                    : item?.paymentGateway?.status
                }
              />
            </div>
          ),
        },
        {
          _id: 12,
          type: "action",
          align: "left",
          // cellClass: "w-[5%]",
          actionData: [
            {
              _id: 1,
              name: "View Details",
              icon: "fa-solid fa-eye",
              onClick: () => {
                setDetailsModal({ isOpen: true, data: item });
              },
            },
            // {
            //   _id: 4,
            //   name: "Delete",
            //   icon: "fa-regular fa-trash-can",
            //   standout: true,
            //   onClick: () => {
            //     setDeleteModal({
            //       isOpen: true,
            //       data: item,
            //     });
            //   },
            // },
          ],
        },
      ],
    };
  });

  // add or edit subscription=================>
  //   function faqManageResponse(res) {
  //     if (res?.status === 200 || res?.status === 201) {
  //       if (res?.status === 201) {
  //         if (filters?.page === 1) {
  //           queryClient.setQueryData(
  //             ["subscription", filters, search],
  //             (state) => {
  //               if (state) {
  //                 let stateData = JSON.parse(JSON.stringify(state?.data));
  //                 stateData = [...stateData, res?.data];
  //                 return { ...state, data: stateData };
  //               }
  //             }
  //           );
  //           if (data?.metadata?.totalDocs > filters?.limit) {
  //             queryClient.invalidateQueries(["subscription", filters, search]);
  //           }
  //         } else {
  //           setFilters((pre) => ({ ...pre, page: 1 }));
  //         }
  //       }
  //       if (res?.status === 200) {
  //         queryClient.setQueryData(["subscription", filters, search], (state) => {
  //           if (state) {
  //             let stateData = JSON.parse(JSON.stringify(state?.data));
  //             stateData = stateData?.map((item) =>
  //               item?._id === res?.data?._id ? { ...item, ...res?.data } : item
  //             );
  //             return { ...state, data: stateData };
  //           }
  //         });
  //         if (data?.metadata?.totalDocs > filters?.limit) {
  //           queryClient.invalidateQueries(["subscription", filters, search]);
  //         }
  //       }
  //       setModalOpen({ isOpen: false, data: null });
  //     } else {
  //       toast.warning(res?.message || res?.error);
  //     }
  //   }
  function subscriptionManageResponse(res) {
    if (res?.status === 200 || res?.status === 201) {
      if (res?.status === 201) {
        if (filters?.page === 1) {
          updateData((pre) => ({ ...pre, data: [res?.data, ...pre?.data] }));
          refetch();
        } else {
          setFilters((pre) => ({ ...pre, page: 1 }));
        }
      }
      if (res?.status === 200) {
        updateData((pre) => ({
          ...pre,
          data: pre?.data?.map((item) =>
            item?._id === res?.data?._id ? res?.data : item
          ),
        }));
      }
      setModalOpen({ isOpen: false, data: null });
    } else {
      toast.warning(res?.message);
    }
  }

  //   subscription delete handler =================>
  const { mutate: deleteHandler, isPending: deletePending } = useMutation({
    mutationFn: async (payload) => {
      const res = await subscriptionDelete({
        ids: Array.isArray(payload) ? payload : [payload],
      });
      return { res, payload: Array.isArray(payload) ? payload : [payload] };
    },
    onSuccess: ({ res, payload }) => {
      if (res?.status === 200) {
        setDeleteModal({ isOpen: false, data: null });
        updateData((pre) => {
          pre.data = (pre?.data || [])?.filter(
            (item) => !payload?.includes(item?._id)
          );
          return { ...pre };
        });
        if (data?.metadata?.totalDocs > filters?.limit) {
          refetch();
        }
      }
    },
    onError: (error) => {
      console.log(error);
    },
  });

  return (
    <div className="space-y-4 w-full flex flex-col pb-10">
      <div className="space-y-8">
        <div className="font-bold text-center text-lg xl:text-3xl text-chestnut-rose">
          Subscriptions Management
        </div>
        <div className="flex items-center gap-3">
          <div className="w-36">
            <LimitSelect
              value={filters?.limit}
              allValue={data?.metadata?.totalDocs}
              onChange={(val) => handleFilterChange("limit", val, setFilters)}
            />
          </div>
          <div className="w-72">
            <Search
              placeholder={"Search here"}
              search={(val) => {
                setKeyword(val);
                handleFilterChange("page", 1, setFilters);
              }}
            />
          </div>
          {/* <div className="relative">
            <Button
              buttonClasses={
                "!bg-transparent border border-transparent !h-10 hover:!bg-chestnut-rose/10 hover:!border-chestnut-rose/10"
              }
              buttonLabel={"Create New"}
              buttonLabelClasses={"font-medium !text-sm text-chestnut-rose"}
              buttonFunction={() => setModalOpen({ isOpen: true, data: null })}
            />
          </div> */}
        </div>
      </div>

      <Table
        tableHeadData={tableHeadData}
        tableData={tableData}
        isLoder={isLoading}
        pageCount={data?.metadata?.totalPages}
        currentPage={filters?.page}
        onPageChange={(val) => {
          handleFilterChange("page", val, setFilters);
          setSelectedItems([]);
        }}
        isFetching={isFetching}
        selectedItems={selectedItems}
        setSelectedItems={setSelectedItems}
        tableActionDropdownContainer={"!w-48"}
      />

      <SubscriptionDetailsDrawer
        open={detailsModal?.isOpen}
        data={detailsModal?.data}
        close={() => setDetailsModal({ isOpen: false, data: null })}
      />

      {/* <ManageSubscriptionDrawer
        open={modalOpen?.isOpen}
        data={modalOpen?.data}
        close={() => setModalOpen({ isOpen: false, data: null })}
        getResponse={subscriptionManageResponse}
      /> */}
      {/* <SubscriptionModal
        open={deleteModal?.isOpen}
        loading={statusChangeInPending}
        onClose={() => setDeleteModal((pre) => ({ data: null, isOpen: false }))}
        title="Cancel Recurring Payment"
        customMessage="Confirm cancellation of recurring payment?"
        deleteHandler={() => {
          statusChangeHandler({
            id: deleteModal?.data?.subscription?._id,
            status: deleteModal?.data?.subscription?.status,
          });
        }}
      /> */}
      {/* <DeleteModal
        open={deleteModal?.isOpen}
        loading={deletePending}
        onClose={() => setDeleteModal((pre) => ({ data: null, isOpen: false }))}
        deleteHandler={() => {
          deleteHandler(deleteModal?.data?._id);
        }}
      /> */}
    </div>
  );
};

export default Subscription;
